import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle, Circle } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

function PreConsultResponses({ patientId, showPdfExport }) {
  const [responses, setResponses] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [saving, setSaving] = useState(null);
  useEffect(() => {
    (async () => { try { const { data } = await axios.get(`${API}/api/patients/${patientId}/pre-consultation-responses`); setResponses(data || []); } catch {} })();
  }, [patientId]);
  if (responses.length === 0) return null;
  const downloadPdf = async (progType) => {
    try {
      const r = await axios.get(`${API}/api/patients/${patientId}/pre-consultation-pdf/${progType}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const a = document.createElement('a'); a.href = url; a.download = `questionario_pre_consulta.pdf`; a.click();
      toast.success('PDF gerado');
    } catch { toast.error('Erro ao gerar PDF'); }
  };
  const toggleReviewed = async (progType, current) => {
    const next = !current;
    setSaving(progType);
    try {
      await axios.put(`${API}/api/patients/${patientId}/pre-consultation-reviewed`, { reviewed: next, program_type: progType });
      setResponses(prev => prev.map(r => r.program_type === progType ? { ...r, reviewed_by_nutri: next } : r));
      toast.success(next ? 'Marcado como revisto' : 'Marcado como por rever');
      window.dispatchEvent(new Event('nav-badges-refresh'));
    } catch { toast.error('Erro ao atualizar'); }
    finally { setSaving(null); }
  };
  return (
    <div className="mt-4" data-testid="pre-consult-responses">
      <p className="text-[10px] text-brand-muted uppercase tracking-wider mb-2">Questionários pré-consulta</p>
      {responses.map((r, ri) => {
        const isExpanded = expanded === ri;
        const reviewed = !!r.reviewed_by_nutri;
        return (
          <div key={ri} className="bg-white border border-brand-border rounded-xl mb-2 overflow-hidden" data-testid={`pre-consult-card-${r.program_type}`}>
            <div className="w-full flex items-center justify-between p-3 hover:bg-brand-bg/30">
              <button onClick={() => setExpanded(isExpanded ? null : ri)} className="flex items-center gap-2 text-left flex-1">
                <span className="text-[9px] bg-brand-green/10 text-brand-green px-2 py-0.5 rounded-full">{r.program_type}</span>
                <span className="text-xs text-brand-text">Concluído: {r.completed_at?.split('T')[0]}</span>
                {reviewed && <span className="text-[9px] bg-brand-mint/20 text-brand-green px-2 py-0.5 rounded-full" data-testid={`reviewed-badge-${r.program_type}`}>Revisto</span>}
              </button>
              <div className="flex items-center gap-3 flex-shrink-0">
                <button
                  onClick={() => toggleReviewed(r.program_type, reviewed)}
                  disabled={saving === r.program_type}
                  className={`flex items-center gap-1 text-[10px] font-medium rounded-full px-2.5 py-1 transition-colors disabled:opacity-50 ${reviewed ? 'bg-brand-mint/20 text-brand-green' : 'bg-brand-bg text-brand-muted border border-brand-border hover:border-brand-green hover:text-brand-green'}`}
                  data-testid={`mark-reviewed-${r.program_type}`}
                >
                  {reviewed ? <CheckCircle size={13} weight="fill" /> : <Circle size={13} />}
                  {reviewed ? 'Revisto' : 'Marcar como revisto'}
                </button>
                <button onClick={() => setExpanded(isExpanded ? null : ri)} className="text-[9px] text-brand-green">{isExpanded ? 'Fechar' : 'Ver'}</button>
              </div>
            </div>
            {isExpanded && (
              <div className="border-t border-brand-border/50 p-3 space-y-2">
                <p className="text-[9px] text-brand-muted">Condições aceites em: {r.conditions_accepted_at?.split('T')[0]}</p>
                {(r.responses || []).map((resp, i) => (
                  <div key={i} className="bg-brand-bg/30 rounded-lg px-3 py-2">
                    <p className="text-[10px] text-brand-muted">{resp.label}</p>
                    <p className="text-xs text-brand-text font-medium">{Array.isArray(resp.value) ? resp.value.join(', ') : String(resp.value || '-')}</p>
                  </div>
                ))}
                {showPdfExport && (
                  <button onClick={() => downloadPdf(r.program_type)} className="text-[10px] text-brand-green hover:underline mt-2">Exportar para PDF</button>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default PreConsultResponses;
